import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../MainPages.css';

export default function Financas() {
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em Prestação de Contas</small></p>
            </Col>
            <Col xs="12">
                <h1>Prestação de Contas</h1>
                <h3>Consulte:</h3>
            </Col>
            <Col xs="12">
                <Link to="/financas/gestao-fiscal" title="Listagem de Pessoal">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Gestão Fiscal
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/receitas" title="Planos de Cargos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Receitas
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/despesas" title="Planos de Cargos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Despesas
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/relatorios-atividades" title="Relatórios de Atividades">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Relatórios de Atividades
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/prestacao-contas-anual" title="Servidores Efetivos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Prestação de Contas Anual
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/orcamento" title="Servidores Comissionados">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Orçamento
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/licitacoes" title="Por Lotação">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Licitações
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/dispensa-licitacao" title="Dispensas de Licitação">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Dispensas de licitação (Art. no 75, inciso II da lei 14.133/2021)
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/chamamento-publico" title="Chamamento Público">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Chamamento Publico (Art. 79, inciso I da lei 14.133/2021)
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/contratos" title="Contratos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Contratos
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/gestores-fiscais" title="Gestores e Fiscais de Contratos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Gestores e Fiscais de Contratos
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/transferencias-voluntarias" title="Transferências Voluntárias">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Transferências Voluntárias
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/verbas-indenizatorias" title="Verbas Indenizatórias">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Verbas Indenizatórias 
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/financas/remuneracao-ajuda-deputados" title="Remuneração e Ajuda de Custo dos Deputados">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Remuneração e Ajuda de Custo dos Deputados
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            {/* <Col xs="12">
                <Link to="/financas/atas-registro-precos" title="Atas de Registro de Preço">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Atas de Registro de Preço
                        </Card.Body>
                    </Card>
                </Link>
            </Col> */}
            <Col xs="12">
                <Link to="/financas/sancionados-administrativamente" title="Licitantes ou Contratados Sancionados Administrativamente">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Licitantes ou Contratados Sancionados Administrativamente
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <Link to="/financas/obras" title="Obras">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Obras
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <Link to="/financas/obras-paralisadas" title="Obras Paralisadas">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Obras Paralisadas
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <Link to="/financas/apreciacao-contas-executivo" title="Obras Paralisadas">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Apreciação de Contas do Executivo Estadual
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <Link to="/financas/convenios" title="Convênios">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Convênios
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
        </Row>
    );
}
